import { initializeNeuroApplication, initializeNeuroGuide } from '@ignitesales/neuro-application';
import App from '../App';
import AppLoading from '../AppLoading';
import loadFonts from '../utils/loadFonts';
import logger from '../utils/logger.mjs';
import messages from '../i18n/messages';
import { questionLayouts } from '../components/questions/index.mjs';
import customMessages from '../i18n/custom';

//TODO: no longer need template content once client UI/UX is implemented
const initGuide = async () => {
  loadFonts();

  await initializeNeuroApplication({
    AppComponent: App,
    AppLoadingComponent: AppLoading,
    messages: messages,
    guideConfig: {
      questionLayouts,
      customMessages: customMessages,
    }
  });

  logger.info('Guide application is ready for takeoff!');
};

initGuide();